const locale = {
	VIEW_ACTIVITIES_TAB_KANBAN: 'Kanban',

	// #region Activities fields
	DETAILS_ACTIVITIES_FIELD_TITLE: 'Titolo',
	DETAILS_ACTIVITIES_FIELD_STATUS: 'Stato Attività',
	DETAILS_ACTIVITIES_FIELD_TYPE: 'Tipo Attività',
	DETAILS_ACTIVITIES_FIELD_COMPANY: 'Azienda',
	DETAILS_ACTIVITIES_FIELD_PERSON: 'Referente esterno',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_GROUP: 'Gruppo assegnato',
	DETAILS_ACTIVITIES_FIELD_DATE_FROM: 'Data disponibilità',
	DETAILS_ACTIVITIES_FIELD_DATE_TO: 'Data scadenza',
	DETAILS_ACTIVITIES_FIELD_DATE_START: 'Data inizio',
	DETAILS_ACTIVITIES_FIELD_DATE_END: 'Data fine',
	DETAILS_ACTIVITIES_FIELD_LENGTH_HOURS: 'Ore previste',
	DETAILS_ACTIVITIES_FIELD_LENGTH_MINUTES: 'Minuti previsti',
	DETAILS_ACTIVITIES_FIELD_TAGS: 'Tag',
	DETAILS_ACTIVITIES_FIELD_WARNING: 'Warning',
	DETAILS_ACTIVITIES_FIELD_BLOCKED: 'Bloccato'
	// #endregion
};

export default locale;
